import React, { useState } from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { RotateIcon } from '@rbilabs/components-library/build/components/rotate-icon';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import theme from './theme';

const PhoneNumberInformation = styled.div`
  font-size: 0.75rem;
  color: ${theme.phoneNumberInformationColor};
  text-align: center;
  margin-top: 0.75rem;
`;

const PhoneNumberToggle = styled.button`
  background: none;
  border: none;
  margin: 0 auto;
  font-size: 0.75rem;
  font-weight: bold;
  font-family: ${Styles.fontFamily.base};
  display: flex;
  align-items: center;
`;

const PhoneAddressInformationToggle = () => {
  const [visible, setVisible] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <div>
      <PhoneNumberToggle
        type="button"
        onClick={() => setVisible(!visible)}
        aria-expanded={visible}
        aria-controls="phoneNumberDisclaimer"
      >
        {formatMessage({ id: 'whyDoYouNeedMyPhoneNumber' })}{' '}
        <RotateIcon active={visible}>
          <Icon icon="select" color="icon-default" width="24px" aria-hidden />
        </RotateIcon>
      </PhoneNumberToggle>
      {visible && (
        <PhoneNumberInformation id="phoneNumberDisclaimer">
          {formatMessage({ id: 'deliveryPhoneDisclosure' })}
        </PhoneNumberInformation>
      )}
    </div>
  );
};

export default PhoneAddressInformationToggle;
